'use client';

import { useIntl } from 'react-intl';

import type { TabContentProps } from './types';
import { InvoiceList } from './InvoiceList.client';
import { messages } from './messages';
import { DEFAULT_MAX_AGE_DAYS, PeriodFilter } from '../PeriodFilter/PeriodFilter';

export const TabContent = ({ tab, state }: TabContentProps) => {
  const { formatMessage } = useIntl();
  const { filters, pagination } = state.getTabState(tab);

  const handleMaxAgeDaysChange = (maxAgeDays: number) => {
    state.updateFilters({ maxAgeDays }, tab);
  };

  return (
    <>
      <div className="mb-1">{formatMessage(messages.filterDescription)}</div>
      <div className="mb-4 max-w-xs">
        <PeriodFilter
          value={filters.maxAgeDays ?? DEFAULT_MAX_AGE_DAYS}
          onChange={handleMaxAgeDaysChange}
          label={formatMessage(messages.timeRangeLabel)}
        />
      </div>
      <div className="space-y-2">
        <InvoiceList tab={tab} state={state} isLastPage={pagination.keys.length === 0} />

        {pagination.keys.map((key, index) => (
          <InvoiceList
            key={key}
            tab={tab}
            paginationKey={key}
            state={state}
            isLastPage={index === pagination.keys.length - 1}
          />
        ))}
      </div>
    </>
  );
};
